let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6vzdH"), load("14PRK"), load("6d5PC"), load("8yyrA"), load("60S8F")]).then(() => parcelRequire('8JC1j'));